import request from 'utils/request'

// 查询
export const queryByType = type => request().get(`logo/query/${type}`)

// 上传logo
export const uploadLogo = data =>
  request().post('logo/upload', data, {
    contentType: false,
    processData: false,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })

// 设置系统名称
export const setTitle = data => request(false).post('sys/title/set', data)
